import styled from 'styled-components';

const COLORS = {
  white: '#ffffff',
  ligthGrey: '#E0E0E0',
  focusColor: '#01bfa5',
};

const Label = styled.label`
  color: ${COLORS.darkGrey};
  display: flex;
  flex-direction: column;
  font-family: 'Montserrat';
  font-weight: 600;
  margin-bottom: 23px;
  position: relative;
  width: 100%;

  ${({ customStyle }) => {
    return customStyle;
  }};

  span {
    background-color: ${COLORS.white};
    font-size: 1.2em;
    left: 10px;
    padding: 5px;
    pointer-events: none;
    white-space: nowrap;
    max-width: calc(100% - 22px);
    width: auto;
    text-overflow: ellipsis;
    position: absolute;
    top: -12px;
    transition: all 0.15s ease-in-out;
  }

  input,
  select {
    border: 2px solid ${COLORS.ligthGrey};
    border-radius: 16px;
    min-height: 50px;
    color: ${COLORS.darkGrey};
    font-size: 1.7em;
    padding: 12px 15px;
    transition: border-color 0.2s ease-in-out;
    -webkit-appearance: none;

    &:focus {
      border-color: ${COLORS.focusColor};
    }
  }

  select {
    &:invalid + span {
      color: gray;
    }
  }
`;
/*
 &:not([type='select']):focus + span,
    &:not([type='select']):not(:placeholder-shown) + span {
      color: ${COLORS.labelSmall};
      font-size: 1.2em;
      top: -11px;
    }

*/
export { Label };
